import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {

  baseUrl = environment.apiUrl + '/login';

  constructor(public http: HttpClient) {
  }

  public getRecuperarSenha(cpf: string): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/recuperar-senha', {cpf: cpf}, { headers: this.headers });
  }

  public updateRecuperarSenha(obj: any): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/recuperar-senha', obj, { headers: this.headers });
  }

  public verifyTokenRecover(token: string = null): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/validar-token', {token: token}, { headers: this.headers });
  }

  public updateAlterarSenha(obj: any): Observable<any> {
    return this.http.put<any>(environment.apiUrl + '/alterar-senha', obj, { headers: this.headers });
  }
  public getEntidades(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/entidades',
      {
        headers: this.headers,
        withCredentials: true
      });
  }
  public setUserEntidades(entidadeId: number): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + '/entidades-usuario/' + entidadeId, {},
      {
        headers: this.headers,
        withCredentials: true
      }
    );
  }
  public getUserEntidades(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/entidades-usuario',{ headers: this.headers });
  }

  public get headers(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", 'application/json');
    return headers;
  }
}
